import React from "react";
import { AlertTriangle } from "lucide-react";
import { CLOSURE_HEADING, CLOSURE_MESSAGE_GENERAL } from "@/config/closures";
import { cn } from "@/lib/utils";

interface ClosureNoticeProps {
  /** Override the body copy (e.g. the RV-specific wording). */
  message?: string;
  heading?: string;
  className?: string;
}

export const ClosureNotice: React.FC<ClosureNoticeProps> = ({
  message = CLOSURE_MESSAGE_GENERAL,
  heading = CLOSURE_HEADING,
  className,
}) => {
  return (
    <div
      role="alert"
      className={cn(
        "rounded-lg border-2 border-destructive/40 bg-destructive/10 p-5 md:p-6",
        className
      )}
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-6 w-6 shrink-0 text-destructive mt-0.5" aria-hidden="true" />
        <div>
          <h3 className="text-base md:text-lg font-bold tracking-wide text-destructive">
            {heading}
          </h3>
          <p className="mt-2 text-sm md:text-base text-foreground/80 leading-relaxed">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ClosureNotice;
